import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
export var validateEmail = function validateEmail(email) {
  return /^(?!.*\.{2}.*)[^\s@]+@[^\s@]+\.[^\s@.]{2,3}$/.test(email);
};
export var validatePasswordLength = function validatePasswordLength(password) {
  return /[^]{8,}$/.test(password);
};
export var validatePasswordUppercase = function validatePasswordUppercase(password) {
  return /[A-Z]/.test(password);
};
export var validatePasswordLowercase = function validatePasswordLowercase(password) {
  return /[a-z]/.test(password);
};
export var validatePasswordSpecialCharacter = function validatePasswordSpecialCharacter(password) {
  return /[^a-zA-Z\d\s:]/.test(password);
};
export var validatePasswordNumber = function validatePasswordNumber(password) {
  return /\d/.test(password);
};
export var validateName = function validateName(name) {
  return /^([^0-9!@#$%^&*(),.?":{}|<>]{2,30})$/.test(name);
};
export var validateCity = function validateCity(name) {
  return /^([^0-9!@#$%^&*(),.?":{}|<>]{2,40})$/.test(name);
};
export var validateCompany = function validateCompany(name) {
  return /^([^!@#$%^&*(),.?":{}|<>]{2,80})$/.test(name);
};
export var validateAddress = function validateAddress(name) {
  return /^([^!@#$%^&*()?":{}|<>]{2,110})$/.test(name);
};
export var validateBirthDay = function validateBirthDay(birthDay) {
  return /^\s*(3[01]|[12][0-9]|0?[1-9])\/(1[012]|0?[1-9])\/((?:19|20)\d{2})\s*$/g.test(birthDay);
};
export var validateGiftCard = function validateGiftCard(gc) {
  return /^[0-9]{13}$/.test(gc);
}; // TODO change to proper validation regex

export var validateBicCode = function validateBicCode(bicCode) {
  return /([a-zA-Z]{4})([a-zA-Z]{2})(([2-9a-zA-Z]{1})([0-9a-np-zA-NP-Z]{1}))((([0-9a-wy-zA-WY-Z]{1})([0-9a-zA-Z]{2}))|([xX]{3})|)/g.test(bicCode);
}; // TODO change to proper validation regex

export var validateIban = function validateIban(iban) {
  return /[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{4}[0-9]{7}([a-zA-Z0-9]?){0,16}/g.test(iban);
};